import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import plusimg from "../assets/images/dasboard/pluse.webp";
import minusimg from "../assets/images/dasboard/minus.webp";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import {
  POST_BP_LAST_LOG,
  POST_BP_LOG,
  POST_WATER_INTAKE,
} from "../config/ApisCollection";

const BPLogPopup = ({
  isBpLogOpen,
  setBpLogOpen,
  currentBPValue,
  handleDashboardApi,
}) => {
  const [BPnum, setBPNum] = useState(currentBPValue);
  const [msg, setMsg] = useState(null);
  const [systolic, setSystolic] = useState(currentBPValue?.systolic || 120);
  const [diastolic, setDiastolic] = useState(currentBPValue?.diastolic || 80);
  const accessToken = secureLocalStorage.getItem("accessToken");

  const UpdateBPLOG = async () => {
    const post_body = {
      systolic: systolic,
      diastolic: diastolic,
    };

    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios.post(POST_BP_LOG, post_body, post_header).then((response) => {
        console.log(response);
        if (response.data) {
          setMsg(response.data.message);
          handleDashboardApi();
        }
      });
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMsg(null);
      setBpLogOpen(false);
    }, 3000);
  };

  const getBPLogData = async () => {
    const post_body = {};
    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    await axios
      .post(POST_BP_LAST_LOG, post_body, post_header)
      .then((response) => {
        // console.log(response);
        // {"message":"Blood pressure record saved successfully.","data":null}
        if (response?.data?.data?.systolic) {
          setSystolic(response?.data?.data?.systolic);
          setDiastolic(response?.data?.data?.diastolic);
        }
      });
  };
  useEffect(() => {
    // getBPLogData();
  }, []);

  return (
    <Popup
      open={isBpLogOpen}
      onClose={() => {
        setBpLogOpen(false);
      }}
      position="right center"
    >
      <div>
        <h1 className="text-center text-xl">
          What is your
          <span className="text-orange"> blood pressure today</span>?
        </h1>
        <p className="text-xs text-center mt-2">
          We recommend measuring the blood pressue at the same time daily.
        </p>
      </div>
      {/* systolic */}
      <div className="flex justify-evenly mt-10 px-5 gap-5">
        <div className="flex flex-col p-2 text-center rounded-2xl justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              if (systolic > 90) {
                setSystolic(systolic - 1);
              } else {
                setMsg("Invalid systolic");
              }
            }}
          >
            <img src={minusimg} className="m-auto" />
          </button>
        </div>
        <div className="flex flex-col p-2 text-center gap-2">
          <h1 className="text-3xl">{systolic}</h1>
          <p className="text-xs">Systolic mm/hg</p>
        </div>
        <div className="flex flex-col p-2 text-center  justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              systolic < 300
                ? setSystolic(systolic + 1)
                : setMsg("Invalid systolic");
            }}
          >
            <img src={plusimg} className="m-auto" />
          </button>
        </div>
      </div>
      {/* systolic */}
      <div className="flex justify-evenly mb-10 px-5 gap-5">
        <div className="flex flex-col p-2 text-center rounded-2xl justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              if (diastolic > 60) {
                setDiastolic(diastolic - 1);
              } else {
                setMsg("Invalid diastolic");
              }
            }}
          >
            <img src={minusimg} className="m-auto" />
          </button>
        </div>
        <div className="flex flex-col p-2 text-center gap-2">
          <h1 className="text-3xl">{diastolic}</h1>
          <p className="text-xs">Diastolic mm/hg</p>
        </div>
        <div className="flex flex-col p-2 text-center  justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              if (diastolic < 200) {
                setDiastolic(diastolic + 1);
              } else {
                setMsg("Invalid diastolic");
              }
            }}
          >
            <img src={plusimg} className="m-auto" />
          </button>
        </div>
      </div>
      <div className="items-center ">
        <p className="text-[#28a745] text-center mb-2 text-capitalize">{msg}</p>
        {/* <h1 className="text-center text-xs !mb-3">1 glass = 250 ml </h1> */}
        <button
          className="px-5 py-2 text-center bg-orange !text-[#fff] rounded-xl shadow-2xl w-full "
          onClick={UpdateBPLOG}
        >
          Update blood pressure
        </button>
      </div>
    </Popup>
  );
};

export default BPLogPopup;
